import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { KPI_DIMENSIONS_MAP } from '@src/utils/kpi';
import { kpiMetricSelector } from '../base/selectors';
import { metricKeys } from '@pulse/metrics';

const selector = (state) => get(state, SCOPE);

export const dimensionTableColumnsSelector = createSelector(
  kpiMetricSelector,
  (kpiMetric) => KPI_DIMENSIONS_MAP[kpiMetric || metricKeys.StreamingPerformanceIndex] || [kpiMetric],
);

export default selector;
